import { Namefully, NameOrder } from 'namefully'

/**
 * Format a person's name for display using namefully.
 * Returns "First [Middle] Last" (NameOrder.FIRST_NAME). Handles various raw
 * formats (e.g. "Last First", "First Last"); pass orderedBy when you know the input order.
 */
export function formatName(
  raw: string | undefined | null,
  orderedBy: NameOrder = NameOrder.FIRST_NAME,
): string {
  if (raw == null || raw.trim() === '') return ''

  try {
    const name = new Namefully(raw.trim(), { orderedBy })
    return name.fullName(orderedBy)
  } catch {
    return raw.trim()
  }
}
